import { render, staticRenderFns } from "./UserRoleForm.vue?vue&type=template&id=f4547a72&scoped=true"
import script from "./UserRoleForm.vue?vue&type=script&lang=js"
export * from "./UserRoleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4547a72",
  null
  
)

export default component.exports